module.exports = __webpack_public_path__ + "static/sdk-poster-2f26bc04173a7686edbf93348f58cd94.jpg";